<script setup lang="ts">
import {
  Send,
} from "@lucide/vue";

defineProps<{
  loading?: boolean;
}>();

const emit = defineEmits<{
  cancel: [];
  confirm: [];
}>();
</script>

<template>
  <div class="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
    <el-button
      class="!m-0 w-full sm:w-auto"
      :disabled="loading"
      @click="emit('cancel')"
    >
      {{ $t('COMMON.CANCEL') }}
    </el-button>

    <el-button
      class="!m-0 w-full sm:w-auto"
      type="primary"
      :loading="loading"
      @click="emit('confirm')"
    >
      <Send
        class="mr-1.5"
        :size="16"
      />
      {{ $t('SUPPORT.BTN_SEND') }}
    </el-button>
  </div>
</template>
